module.exports = __webpack_public_path__ + "img/Icon-24.be0b8dd6.png";